import Vue from "vue";
import {sortByAuth} from "@/utils/group";
import {jointContexts, obtainPickSingleParent, pickSingleIntValue, pickSingleValue, PRESETS} from "@/utils/pick";
import * as userUtils from "@/utils/user";

export const initPicksInArea = (area) => {
    return;

    if (!area.picks) Vue.set(area, "picks", []);

    const contexts = jointContexts(area);
    area.picks?.filter(el=>!el.isSearch)?.forEach(pick => {
        //const user = state.session.user;
        //sortByAuth(area.picks, user.favUserSort, "contextId");

        //console.log("PICK "+pick.id+": ", pick.conds);

        // 1. add to picks some props of base contexts
        const contextId = pickSingleValue(pick, "contextId");
        //console.log("PICK "+pick.id+" contextId: ", contextId);
        let context = pick;
        if ( contextId ) context = contexts.find(el => el.contextId === contextId);
        //console.log("context OF PICK "+pick.id+": ", context);
        if (context?.isGroup) {
            if (context.image) Vue.set(pick, "image", context.image);
            Vue.set(pick, "shouldBeWithLogo", true);
            Vue.set(pick, "withTopics", context.withTopics);
            Vue.set(pick, "isPersonal", context.isPersonal);
        } else if (context?.isUser) {
            if (context.avatar) Vue.set(pick, "avatar", context.avatar);
            Vue.set(pick, "shouldBeWithAvatar", true);
        } else {
            // finally check pick for assignee
            const userId = pickSingleIntValue(pick, "userId");
            //console.log("USER ID OF PICK "+pick.id+": "+userId);
            if (userId) {
                const user = area.users.find(el => el.id === userId);
                if (user) {
                    if (user.avatar) Vue.set(pick, "avatar", user.avatar);
                    else Vue.set(pick, "avatarName", userUtils.fi(user));
                    //Vue.set(pick, "shouldBeWithAvatar", true);
                }
            }
        }
    });
};

export const initFavoriteUsersInArea = (area) => {
    if (!area.favoriteUsers) Vue.set(area, "favoriteUsers", []);

    // add avatars to user picks
    if (area.favoriteUsers.length) {
        //const user = state.session.user;
        //console.log("user.favUserSort", user.favUserSort, typeof user.favUserSort);
        //sortByAuth(area.favoriteUsers, user.favUserSort, "contextId");
        area.favoriteUsers?.forEach(userContext => {
            //userContext.isUser = true;
            //const user = area.users.find(el => el.auth === userContext.auth);
            //if (user) userContext.avatar = user.avatar;
            //console.log("userContext.avatar", userContext.avatar);
        });
    }

    //console.log("AREA USER PICKS INITED", area.favoriteUsers);
};

export const sortAllContextsChildren = (area, user) => {
    area.picks?.forEach(context => {
        sortContextChildren(context, area, user);
        context.children?.forEach(child => {
            sortContextChildren(child, area, user);
            child.children?.forEach(child => {
                sortContextChildren(child, area, user);
                child.children?.forEach(child => {
                    sortContextChildren(child, area, user);
                });
            });
        });
    });
    area.favoriteUsers?.forEach(context => {
        sortContextChildren(context, area, user);
        context.children?.forEach(child => {
            sortContextChildren(child, area, user);
            child.children?.forEach(child => {
                sortContextChildren(child, area, user);
                child.children?.forEach(child => {
                    sortContextChildren(child, area, user);
                });
            });
        });
    });
}

export const sortContextChildren = (context, area, user) => {
    if (!context) return;
    const children = context.children;
    if (!children?.length) return;
    const firstChild = children[0];
    if (firstChild.isGroup) {
        sortByAuth(children, user.groupSort, "id");
    } else if (firstChild.isTopic) {
        const group = area.groups?.find(el => el.id === firstChild.groupId);
        if (group) sortByAuth(children, group.topicSort);
    } else if (firstChild.isTag) {
        const topic = area.topics?.find(el => el.id === firstChild.topicId);
        console.log("SORTING TAGS WITH ", topic?.tagSort);
        if (topic) sortByAuth(children, topic.tagSort);
    }
}
